import React from 'react';
import { Button } from '@chakra-ui/react';

import { useAskAnExpertButton } from './useAskAnExpertButton';

export interface AskAnExpertProps {
    isDisabled?: boolean;
    className?: string;
    variant: string;
    initialText?: string;
    id?: string;
    icon?: React.ReactElement;
}

export const AskAnExpert: React.FC<AskAnExpertProps> = ({ isDisabled, className, variant, initialText, id, icon }) => {
    const { onClick, label, disabled, enabled } = useAskAnExpertButton({ question: initialText, questionId: id });

    if (!enabled) {
        return null;
    }

    return (
        <Button
            data-testid="ask-an-expert.button.ask"
            variant={variant}
            leftIcon={icon}
            onClick={onClick}
            isDisabled={isDisabled || disabled}
        >
            <span className={className}>{label}</span>
        </Button>
    );
};
